<template>
    <div class="trip-modal-wrapper" v-if="visible" @click.self="handleClose">
        <div class="trip-modal">
            <!-- 标题 -->
            <div class="trip-modal-header">
                <div class="trip-modal-title">运输总车次</div>
                <span class="trip-modal-close" @click="handleClose">&times;</span>
            </div>

            <!-- 统计行 -->
            <div class="trip-modal-stats">
                <div class="trip-stat-item stat-loading"
                    :class="{ 'stat-selected': selectedStatuses.indexOf('inTransit') !== -1 }"
                    @click="toggleStatus('inTransit')">
                    <div class="stat-icon-wrap">
                        <img class="stat-icon" src="../../assets/img/transport/icon-transportation.png" alt="">
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">运输中</div>
                        <div class="stat-value">{{ summaryData.inTransitCount || 0 }} <span class="stat-unit">车次</span>
                        </div>
                    </div>
                    <div class="stat-check" v-if="selectedStatuses.indexOf('inTransit') !== -1">
                        <svg viewBox="0 0 24 24" fill="#23CB99">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 12l3 3 5-5" stroke="#fff" stroke-width="2" fill="none" />
                        </svg>
                    </div>
                </div>

                <div class="trip-stat-item stat-transit"
                    :class="{ 'stat-selected': selectedStatuses.indexOf('loading') !== -1 }"
                    @click="toggleStatus('loading')">
                    <div class="stat-icon-wrap">
                        <img class="stat-icon" src="../../assets/img/transport/icon-charging.png" alt="">
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">装料中</div>
                        <div class="stat-value">{{ summaryData.loadingCount || 0 }} <span class="stat-unit">车次</span>
                        </div>
                    </div>
                    <div class="stat-check" v-if="selectedStatuses.indexOf('loading') !== -1">
                        <svg viewBox="0 0 24 24" fill="#23CB99">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 12l3 3 5-5" stroke="#fff" stroke-width="2" fill="none" />
                        </svg>
                    </div>
                </div>

                <div class="trip-stat-item stat-unloading"
                    :class="{ 'stat-selected': selectedStatuses.indexOf('unloading') !== -1 }"
                    @click="toggleStatus('unloading')">
                    <div class="stat-icon-wrap">
                        <img class="stat-icon" src="../../assets/img/transport/icon-discharge.png" alt="">
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">卸料中</div>
                        <div class="stat-value">{{ summaryData.unloadingCount || 0 }} <span class="stat-unit">车次</span>
                        </div>
                    </div>
                    <div class="stat-check" v-if="selectedStatuses.indexOf('unloading') !== -1">
                        <svg viewBox="0 0 24 24" fill="#FF9616">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 12l3 3 5-5" stroke="#fff" stroke-width="2" fill="none" />
                        </svg>
                    </div>
                </div>

                <div class="trip-stat-item stat-completed"
                    :class="{ 'stat-selected': selectedStatuses.indexOf('completed') !== -1 }"
                    @click="toggleStatus('completed')">
                    <div class="stat-icon-wrap">
                        <img class="stat-icon" src="../../assets/img/transport/icon-complete.png" alt="">
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">已完成</div>
                        <div class="stat-value">{{ summaryData.completedCount || 0 }} <span class="stat-unit">辆</span>
                        </div>
                    </div>
                    <div class="stat-check" v-if="selectedStatuses.indexOf('completed') !== -1">
                        <svg viewBox="0 0 24 24" fill="#23CB99">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 12l3 3 5-5" stroke="#fff" stroke-width="2" fill="none" />
                        </svg>
                    </div>
                </div>
            </div>

            <!-- 车次卡片列表 -->
            <div class="trip-modal-body">
                <div class="trip-grid">
                    <template v-for="(group, gi) in paginatedGroups">
                        <!-- 小卡片组: 装料中+运输中 两两一组 -->
                        <div class="trip-group trip-group-small" v-if="group.type === 'small'"
                            :key="group.cards[0] ? 'g-' + group.cards[0].plate : 'gs-' + gi">
                            <div class="trip-card trip-card-small" v-for="(trip, ti) in group.cards"
                                :key="'s-' + gi + '-' + ti">
                                <div class="trip-card-header">
                                    <img v-if="trip.statusType === 'loading'" class="trip-card-header-icon"
                                        src="@/assets/img/transport/icon-charging.png" alt="">
                                    <img v-else class="trip-card-header-icon"
                                        src="@/assets/img/transport/icon-transportation.png" alt="">
                                    <div class="trip-card-header-info">
                                        <div class="info-title">{{ trip.plate }}</div>
                                        <div class="info-sub">
                                            <div class="info-sub-item">
                                                <span>运输时长：</span>
                                                <span class="info-sub-item-content">{{ trip.duration && trip.duration +
                                                    'min' || '-' }}</span>
                                            </div>
                                            <div class="info-sub-item">
                                                <span>混合料：</span>
                                                <span class="info-sub-item-content">{{ trip.material || '-' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="trip-status" :class="'status-' + trip.statusType">{{ trip.statusText }}
                                    </div>
                                </div>
                                <div class="trip-card-body">
                                    <div class="trip-card-body-item">
                                        <div class="trip-field">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-mixingplant.png"
                                                    alt="">
                                                <div class="field-label">拌合楼</div>
                                            </div>
                                            <el-tooltip v-if="trip.mixingPlant" :content="trip.mixingPlant" placement="top" effect="dark">
                                                <div class="field-value">{{ trip.mixingPlant }}</div>
                                            </el-tooltip>
                                            <div v-else class="field-value">-</div>
                                        </div>
                                        <div class="trip-field-right">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-date.png" alt="">
                                                <div class="field-label">装料时间</div>
                                            </div>
                                            <div class="field-value" style="display: flex; gap: 16px;">
                                                <span>{{ trip.loadingTime || '-' }}</span>
                                                <span v-if="trip.loadingMinutes">{{ trip.loadingMinutes }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 大卡片组: 卸料中/已完成 单独一组 -->
                        <div class="trip-group trip-group-large" v-if="group.type === 'large'"
                            :key="group.cards[0] ? 'g-' + group.cards[0].plate : 'gl-' + gi">
                            <div class="trip-card trip-card-large" v-for="(trip, ti) in group.cards"
                                :key="'l-' + gi + '-' + ti">
                                <div class="trip-card-header">
                                    <img v-if="trip.statusType == 'unloading'" class="trip-card-header-icon"
                                        src="@/assets/img/transport/icon-discharge.png" alt="">
                                    <img v-else class="trip-card-header-icon" src="@/assets/img/transport/icon-complete.png"
                                        alt="">
                                    <div class="trip-card-header-info">
                                        <div class="info-title">{{ trip.plate || '-' }}</div>
                                        <div class="info-sub">
                                            <div class="info-sub-item">
                                                <span>运输时长：</span>
                                                <span class="info-sub-item-content">{{ trip.duration && trip.duration +
                                                    'min' || '-' }}</span>
                                            </div>
                                            <div class="info-sub-item">
                                                <span>混合料：</span>
                                                <span class="info-sub-item-content">{{ trip.material || '-' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="trip-status" :class="'status-' + trip.statusType">{{ trip.statusText }}
                                    </div>
                                </div>
                                <div class="trip-card-body">
                                    <div class="trip-card-body-item">
                                        <div class="trip-field">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-mixingplant.png"
                                                    alt="">
                                                <div class="field-label">拌合楼</div>
                                            </div>
                                            <el-tooltip v-if="trip.mixingPlant" :content="trip.mixingPlant" placement="top" effect="dark">
                                                <div class="field-value">{{ trip.mixingPlant }}</div>
                                            </el-tooltip>
                                            <div v-else class="field-value">-</div>
                                        </div>
                                        <div class="trip-field-right">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-date.png" alt="">
                                                <div class="field-label">装料时间</div>
                                            </div>
                                            <div class="field-value" style="display: flex; gap: 16px;">
                                                <span>{{ trip.loadingTime || '-' }}</span>
                                                <span v-if="trip.loadingMinutes">{{ trip.loadingMinutes }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="trip-card-body-item">
                                        <div class="trip-field">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-pave.png" alt="">
                                                <div class="field-label">摊铺机</div>
                                            </div>
                                            <div class="field-value">{{ trip.paver || '-' }}</div>
                                        </div>
                                        <div class="trip-field-right">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-date.png" alt="">
                                                <div class="field-label">摊铺时间</div>
                                            </div>
                                            <div class="field-value" style="display: flex; gap: 16px;">
                                                <span>{{ trip.pavingTime || '-' }}</span>
                                                <span v-if="trip.pavingMinutes">{{ trip.pavingMinutes }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="trip-card-body-item">
                                        <div class="trip-field">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-layer.png" alt="">
                                                <div class="field-label">路幅层位</div>
                                            </div>
                                            <div class="field-value">{{ trip.roadLayer || '-' }}</div>
                                        </div>
                                        <div class="trip-field-right">
                                            <div class="trip-field-header">
                                                <img class="field-icon" src="@/assets/img/transport/icon-pileno.png" alt="">
                                                <div class="field-label">摊铺桩号</div>
                                            </div>
                                            <div class="field-value">{{ trip.pavingStation || '-' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- 空状态 -->
                <div class="trip-empty" v-if="!loading && tripList.length === 0">
                    暂无车次数据
                </div>

                <!-- 加载中 -->
                <div class="trip-loading" v-if="loading">
                    加载中...
                </div>
            </div>

            <!-- 分页 -->
            <div class="trip-modal-footer" v-if="totalPages > 1">
                <button class="page-btn" :disabled="currentPage <= 1" @click="goPage(currentPage - 1)">&lt;</button>
                <button v-for="p in displayPages" :key="p" class="page-btn page-num"
                    :class="{ active: p === currentPage }" @click="goPage(p)">{{ p }}</button>
                <button class="page-btn" :disabled="currentPage >= totalPages"
                    @click="goPage(currentPage + 1)">&gt;</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getTransportTodaySummary, getTransportListDetail, getCurrentTime } from '@/api/api'

export default {
    name: 'TripInfo',
    props: {
        type: {
            type: String,
            default: 'lq'
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            // 统计数据
            summaryData: {
                loadingCount: 0,
                inTransitCount: 0,
                unloadingCount: 0,
                completedCount: 0
            },
            // 车次列表
            tripList: [],
            // 筛选状态
            selectedStatuses: [],
            // 分页（按组分页）
            currentPage: 1,
            pageSize: 6, // 每页6组（3列×2行）
            totalCount: 0
        }
    },
    computed: {
        ...mapState(['sectionId', 'mixplantId', 'seIds']),
        // 筛选后的列表数据
        filteredTripList() {
            var list = this.tripList || []
            var selected = this.selectedStatuses
            // 全部不选或全选时展示所有
            if (selected.length === 0 || selected.length >= 4) return list
            return list.filter(function (t) { return selected.indexOf(t.statusType) !== -1 })
        },
        // 将数据分组: 装料中/运输中为小卡片(两两一组), 卸料中/已完成为大卡片(单独一组)
        groupedTripList() {
            var list = this.filteredTripList
            // 分离小卡片和大卡片数据
            const smallCards = list.filter(function (t) { return t.statusType === 'loading' || t.statusType === 'inTransit' })
            const largeCards = list.filter(function (t) { return t.statusType === 'unloading' || t.statusType === 'completed' })
            // 大卡片排序: 卸料中在前, 已完成在后
            const statusOrder = { unloading: 0, completed: 1 }
            largeCards.sort(function (a, b) { return (statusOrder[a.statusType] || 0) - (statusOrder[b.statusType] || 0) })

            var groups = []
            // 小卡片两两分组
            for (var i = 0; i < smallCards.length; i += 2) {
                groups.push({
                    type: 'small',
                    cards: smallCards.slice(i, i + 2)
                })
            }
            // 大卡片单独分组
            largeCards.forEach(function (card) {
                groups.push({
                    type: 'large',
                    cards: [card]
                })
            })
            return groups
        },
        // 总组数
        totalGroups() {
            return this.groupedTripList.length
        },
        // 当前页的分组数据
        paginatedGroups() {
            var start = (this.currentPage - 1) * this.pageSize
            var end = start + this.pageSize
            return this.groupedTripList.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.totalGroups / this.pageSize) || 1
        },
        displayPages() {
            const total = this.totalPages
            const current = this.currentPage
            const pages = []
            if (total <= 7) {
                for (let i = 1; i <= total; i++) pages.push(i)
            } else {
                pages.push(1)
                if (current > 3) pages.push('...')
                const start = Math.max(2, current - 1)
                const end = Math.min(total - 1, current + 1)
                for (let i = start; i <= end; i++) pages.push(i)
                if (current < total - 2) pages.push('...')
                pages.push(total)
            }
            return pages
        }
    },
    methods: {

        toggleStatus(status) {
            var arr = this.selectedStatuses.slice()
            var idx = arr.indexOf(status)
            if (idx === -1) {
                arr.push(status)
            } else {
                arr.splice(idx, 1)
            }
            this.selectedStatuses = arr
            this.currentPage = 1
            console.log('[toggleStatus] selectedStatuses:', JSON.stringify(arr))
            console.log('[toggleStatus] tripList length:', this.tripList.length)
            console.log('[toggleStatus] filteredTripList length:', this.filteredTripList.length)
            console.log('[toggleStatus] groupedTripList length:', this.groupedTripList.length)
        },
        open() {
            this.visible = true
            this.currentPage = 1
            this.selectedStatuses = []
            this.fetchData()
        },
        handleClose() {
            this.visible = false
        },
        goPage(page) {
            if (page < 1 || page > this.totalPages) return
            this.currentPage = page
        },
        async fetchData() {
            this.loading = true
            try {
                await Promise.all([
                    this.fetchSummary(),
                    this.fetchTripList()
                ])
            } catch (e) {
                console.error('获取车次数据失败', e)
            } finally {
                this.loading = false
            }
        },
        async fetchSummary() {
            try {
                const req = {
                    materialType: this.type || 'lq',
                    mixplantId: this.mixplantId,
                    sectionId: this.seIds
                }
                const res = await getTransportTodaySummary(req)
                if (res && res.data) {
                    const d = res.data
                    // 从flowData或summary中获取各状态数量
                    this.summaryData = {
                        loadingCount: d.loadingCount || (d.loading && d.loading.carNos && d.loading.carNos.length) || 0,
                        inTransitCount: d.inTransitCount || (d.inTransit && d.inTransit.carCount) || 0,
                        unloadingCount: d.unloadingCount || (d.unloading && d.unloading.carNos && d.unloading.carNos.length) || 0,
                        completedCount: d.completedCount || (d.completed && d.completed.carNos && d.completed.carNos.length) || 0
                    }
                }
            } catch (e) {
                console.error('获取统计数据失败', e)
            }
        },
        async fetchTripList() {
            try {
                const now = getCurrentTime()
                const today = now.split(' ')[0]
                const req = {
                    materialType: this.type || 'lq',
                    mixplantIds: this.mixplantId,
                    sectionId: this.seIds,
                    startDate: today,
                    endDate: today,
                    pageNo: 1,
                    pageSize: 10000
                }
                const res = await getTransportListDetail(req)
                const statusMap = {
                    loading: '装料中',
                    inTransit: '运输中',
                    unloading: '卸料中',
                    completed: '已完成'
                }
                console.log('[fetchTripList] res:', res)
                const list = res.data && res.data.list || []
                this.tripList = list.map(raw => {
                    let loadingTime = ''
                    let loadingMinutes = ''
                    if (raw.begingLoadingDate) {
                        loadingTime = raw.begingLoadingDate.slice(0, 16)
                        if (raw.endLoadingDate) {
                            loadingTime += '~' + raw.endLoadingDate.split(' ')[1].slice(0, 5)
                            const mins = Math.round((new Date(raw.endLoadingDate) - new Date(raw.begingLoadingDate)) / 60000)
                            if (!isNaN(mins)) loadingMinutes = mins + 'min'
                        }
                    }

                    let pavingTime = ''
                    let pavingMinutes = ''
                    if (raw.beginSpreadingDate) {
                        pavingTime = raw.beginSpreadingDate.slice(0, 16)
                        if (raw.endSpreadingDate) {
                            pavingTime += '~' + raw.endSpreadingDate.split(' ')[1].slice(0, 5)
                            const mins = Math.round((new Date(raw.endSpreadingDate) - new Date(raw.beginSpreadingDate)) / 60000)
                            if (!isNaN(mins)) pavingMinutes = mins + 'min'
                        }
                    }

                    return {
                        plate: (raw.transporter && raw.transporter.carNo) || '',
                        statusType: raw.transportStatus || 'loading',
                        statusText: statusMap[raw.transportStatus] || '装料中',
                        duration: raw.transportTime || '-',
                        material: (raw.mixture && raw.mixture.typeName) || '',
                        mixingPlant: (raw.batchingPlant && raw.batchingPlant.name) || '',
                        loadingTime,
                        loadingMinutes,
                        paver: (raw.paver && raw.paver.paveNo) || '',
                        pavingTime,
                        pavingMinutes,
                        roadLayer: raw.roadFloatCN && raw.layer && raw.layer.name ? `${raw.roadFloatCN}/${raw.layer.name}` : '',
                        pavingStation: raw.startPileNoStr && raw.endPileNoStr ? `${raw.startPileNoStr}~${raw.endPileNoStr}` : ''
                    }
                })
                this.totalCount = (res && res.count) || this.tripList.length
            } catch (e) {
                console.error('获取车次列表失败', e)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.trip-modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.35);
    // backdrop-filter: blur(12px);
    // -webkit-backdrop-filter: blur(12px);
    z-index: 99999999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.trip-modal {
    width: 90%;
    max-width: 1200px;
    max-height: 85vh;
    background: rgba(9, 23, 71, 0.45);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(0, 89, 148, 1);
    border-radius: 12px;
    box-shadow: 0px 0px 10px 0px rgba(96, 170, 255, 1) inset;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.trip-modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 20px;
    height: 32px;
    position: relative;
    border-bottom: 1px solid rgba(30, 100, 200, 0.2);
    position: relative;

    .trip-modal-title {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        font-family: PingFang SC;
        font-weight: 500;
        font-style: Medium;
        font-size: 18px;
        color: #fff;
        width: 260px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        background-image: url('../../assets/img/transport/modal-headerBg.png');
        background-size: 100% 100%;
    }

    .trip-modal-close {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        color: rgba(255, 255, 255, 0.6);
        font-size: 24px;
        cursor: pointer;

        &:hover {
            color: #fff;
        }
    }
}

// 统计行
.trip-modal-stats {
    display: flex;
    padding: 16px 20px;
    box-sizing: border-box;
    margin: 0 20px;
    gap: 16px;
    background: rgba(0, 17, 74, 0.6);
    border: 1.5px solid rgba(0, 80, 136, 1);
    box-shadow: 0px 0px 6px 0px rgba(21, 126, 206, 0.3);
    box-shadow: 0px 0px 10px 0px rgba(117, 190, 255, 0.4) inset;

    .trip-stat-item {
        flex: 1;
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-radius: 10px;
        position: relative;
        gap: 12px;

        &.stat-loading {
            background: rgba(22, 126, 251, 0.08);
            border: 1px solid rgba(22, 126, 251, 0.3);

            .stat-label {
                color: rgba(45, 108, 245, 1);
            }

            .stat-value {
                color: rgba(45, 108, 245, 1);
            }
        }

        &.stat-transit {
            background: rgba(35, 203, 153, 0.08);
            border: 1px solid rgba(35, 203, 153, 0.3);

            .stat-label {
                color: rgba(35, 203, 153, 1);
            }

            .stat-value {
                color: rgba(35, 203, 153, 1);
            }
        }

        &.stat-unloading {
            background: rgba(255, 150, 22, 0.08);
            border: 1px solid rgba(255, 150, 22, 0.3);

            .stat-label {
                color: rgba(255, 150, 22, 1);
            }

            .stat-value {
                color: rgba(255, 150, 22, 1);
            }
        }

        &.stat-completed {
            background: rgba(150, 150, 150, 0.08);
            border: 1px solid rgba(150, 150, 150, 0.3);

            .stat-label {
                color: #fff;
            }

            .stat-value {
                color: #fff;
            }
        }

        .stat-icon-wrap {
            flex-shrink: 0;
        }

        .stat-icon {
            width: 44px;
            height: 44px;
            // border-radius: 50%;
            // display: flex;
            // align-items: center;
            // justify-content: center;

            // .stat-icon-icon {
            //     width: 24px;
            //     height: 24px;
            // }

            // &.stat-icon-loading {
            //     background: rgba(35, 203, 153, 0.2);
            //     color: #23CB99;
            // }

            // &.stat-icon-transit {
            //     background: rgba(22, 126, 251, 0.2);
            //     color: #167EFB;
            // }

            // &.stat-icon-unloading {
            //     background: rgba(255, 150, 22, 0.2);
            //     color: #FF9616;
            // }

            // &.stat-icon-completed {
            //     background: rgba(150, 150, 150, 0.2);
            //     color: #999;
            // }
        }

        .stat-info {
            flex: 1;

            .stat-label {
                // color: rgba(255, 255, 255, 0.7);
                font-size: 13px;
                margin-bottom: 4px;
            }

            .stat-value {
                // color: #fff;
                font-size: 22px;
                font-weight: 600;

                .stat-unit {
                    font-size: 13px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.6);
                }
            }
        }

        .stat-check {
            position: absolute;
            top: 8px;
            right: 8px;

            svg {
                width: 18px;
                height: 18px;
            }
        }
    }
}

// 卡片列表区域
.trip-modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    min-height: 0;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(30, 100, 200, 0.4);
        border-radius: 3px;
    }

    .trip-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-content: flex-start;
    }

    .trip-group {
        flex: 0 0 calc(33.33% - 11px);
        width: calc(33.33% - 11px);

        &-small {
            display: flex;
            flex-direction: column;
            gap: 16px;
            align-self: flex-start; // 小卡片组顶部对齐
            height: 276px; // 与大卡片组同行等高
        }

        &-large {
            display: flex;
            flex-direction: column;
            align-self: flex-start; // 与大卡片组同行
        }
    }

    .trip-empty,
    .trip-loading {
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        font-size: 14px;
        padding: 40px 0;
    }
}

// 车次卡片
.trip-card {
    background: rgba(0, 17, 74, 0.6);
    border: 1.5px solid rgba(0, 80, 136, 1);
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.3s;
    flex: 0 0 auto;
    padding: 12px 16px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px 0px rgba(21, 126, 206, 0.3);
    box-shadow: 0px 0px 10px 0px rgba(117, 190, 255, 0.4) inset;

    &-small {
        height: 130px;
    }

    &-large {
        height: 276px; // 与小卡片组同行等高
        display: flex;
        flex-direction: column;
        justify-content: center; // 大卡片内容垂直居中
        box-sizing: border-box;
    }

    &:hover {
        border-color: rgba(30, 100, 200, 0.6);
    }

    .trip-card-header {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        box-sizing: border-box;
        // padding: 12px 16px;
        border-bottom: 1px dashed rgba(234, 234, 234, 0.5);
        position: relative;

        .trip-card-header-icon {
            width: 32px;
            height: 32px;
            flex-shrink: 0;
            margin-right: 10px;
        }

        .trip-card-header-info {
            flex: 1;
            min-width: 0;

            .info-title {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 4px;
            }

            .info-sub {
                color: rgba(255, 255, 255, 0.6);
                font-size: 12px;
                display: flex;
                align-items: center;
                gap: 10px;

                .info-sub-item {
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    .info-sub-item-content {
                        color: #167EFB;
                    }
                }
            }
        }

        .trip-status {
            position: absolute;
            top: 8px;
            right: 12px;
            padding: 2px 10px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;

            &.status-loading {
                background: rgba(35, 203, 153, 0.2);
                color: #23CB99;
            }

            &.status-inTransit {
                background: rgba(22, 126, 251, 0.2);
                color: #167EFB;
            }

            &.status-unloading {
                background: rgba(255, 150, 22, 0.2);
                color: #FF9616;
            }

            &.status-completed {
                background: rgba(150, 150, 150, 0.3);
                color: #ccc;
            }
        }
    }

    .trip-card-body {
        padding: 0;

        .trip-card-body-item {
            display: flex;
            padding: 8px 0;
            border-bottom: 1px solid rgba(239, 239, 239, 0.15);

            &:last-child {
                border-bottom: none;
            }
        }

        .trip-field {
            width: 100px;
            min-width: 100px;
            padding-right: 10px;
            border-right: 1px solid rgba(239, 239, 239, 0.5);

            .trip-field-header {
                display: flex;
                align-items: center;
                gap: 4px;
                margin-bottom: 4px;

                .field-icon {
                    width: 16px;
                    height: 16px;
                    flex-shrink: 0;
                }

                .field-label {
                    color: rgba(255, 255, 255, 0.4);
                    font-size: 12px;
                }
            }

            .field-value {
                color: rgba(255, 255, 255, 0.85);
                font-size: 13px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .trip-field-right {
            flex: 1;
            border-right: none;
            padding-left: 12px;
            padding-right: 0;

            .trip-field-header {
                display: flex;
                align-items: center;
                gap: 4px;
                margin-bottom: 4px;

                .field-icon {
                    width: 16px;
                    height: 16px;
                    flex-shrink: 0;
                }

                .field-label {
                    color: rgba(255, 255, 255, 0.4);
                    font-size: 12px;
                }
            }

            .field-value {
                color: rgba(255, 255, 255, 0.85);
                font-size: 13px;
            }
        }
    }
}

// 分页
.trip-modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 20px;
    gap: 4px;
    border-top: 1px solid rgba(30, 100, 200, 0.15);

    .page-btn {
        min-width: 32px;
        height: 32px;
        border: 1px solid rgba(30, 100, 200, 0.3);
        background: transparent;
        color: rgba(255, 255, 255, 0.7);
        border-radius: 4px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;

        &:hover:not(:disabled) {
            border-color: #167EFB;
            color: #fff;
        }

        &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }

        &.page-num.active {
            background: #167EFB;
            border-color: #167EFB;
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/components/tripInfo.vue